import { restApiClient } from '@/datasources';
import { AppointmentRating } from '@/types';

export const getAppointmentPartialRating = async (id: string) => {
  const { data } = await restApiClient.get<AppointmentRating>(`/online/customers/appointments/${id}/partial-rating/`);
  return data?.rating;
};
